// extracted by mini-css-extract-plugin
export default {"scoringAdminPageContainer":"_scoring-admin-page_scoringAdminPageContainer__UHz0b"};